import invariant from 'invariant';

export default function getAllProvinces(params) {
    let { baseUrl, brandId } = params;

    invariant(baseUrl, 'baseUrl is a required param of getAllProvinces()');
    invariant(brandId, 'brandId is a required param of getAllProvinces()');

    // API is a S3 bucket so request is case sensitive
    if (brandId) {
        brandId = brandId.toLowerCase();
    }

    const url = `${baseUrl}api/address_validation/v1/${brandId}/address.json`;
    return new Request(url);
}
